import React, {useState, useEffect, useContext} from 'react'
import { AuthContext } from '../../Context/AuthContext/AuthContext'
import { db } from '../../Firebase/firebase'

const LikePost = ({postID}) => {
  const { currentUser } = useContext(AuthContext)

  const [likedBy, setLikedBy] = useState(0)
  const [userLiked, didUserLike] = useState(false)

  const likePost = () => {
    if(currentUser){
      db.collection('posts').doc(postID).collection('likedBy').add(
        {
          userName: currentUser.displayName
        }
      )
    } else {
      alert("You need to login to like a post")
    }
  }

  const dislikePost = () => {
    if(currentUser){
      db.collection('posts').doc(postID).collection('likedBy').where("userName",'==',currentUser.displayName).get()
        .then(snapshot =>{
          const likeID = snapshot.docs[0].id
          db.collection('posts').doc(postID).collection('likedBy').doc(likeID).delete()
          didUserLike(false)
        })
    }
  }



  useEffect(() => {
    db.collection('posts').doc(postID).collection('likedBy').onSnapshot(snapshot => {
      setLikedBy(snapshot.docs.length)
      didUserLike(false)
      if(currentUser){
        snapshot.docs.map(doc => {
          if(doc.data().userName === currentUser.displayName){
            didUserLike(true)
          }
        })
      }
    })
    
  }, [currentUser])
  return (
    <>
      {userLiked ? (
        <button className="post__heart" onClick={dislikePost}>
          <i className="fas fa-heart" />
          <h1>{likedBy}</h1>
        </button>
      ) : (
        <button className="post__heart" onClick={likePost}>
          <i className="far fa-heart" />
          <h1>{likedBy}</h1>
        </button>
      )}
    </>
  )
}

export default LikePost